import * as React from 'react';
const CommonlandsLogoColorful = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={50}
    height={56}
    fill="none"
    viewBox="0 0 50 56"
    {...props}
  >
    <mask
      id="a"
      width={50}
      height={56}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path fill="#fff" d="M49.412 0H0v56h49.412V0Z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="url(#b)"
        d="M37.917 30.531v-6.018a1.934 1.934 0 0 1 .44-1.261c.294-.36.709-.612 1.174-.714h6.82c.401 0 .8-.076 1.171-.223.372-.147.71-.363.994-.635.284-.271.51-.594.663-.949.154-.355.234-.736.234-1.12v-6.018c0-.385-.08-.765-.233-1.12a2.923 2.923 0 0 0-.664-.95 3.076 3.076 0 0 0-.994-.635 3.184 3.184 0 0 0-1.172-.223h-6.82a2.895 2.895 0 0 1-1.836-.946 2.566 2.566 0 0 1-.415-.668V2.927c0-.776-.323-1.52-.897-2.07A3.137 3.137 0 0 0 34.216 0h-6.82c-.812 0-1.59.308-2.165.857a2.863 2.863 0 0 0-.897 2.07v5.717c-.136.285-.33.54-.57.752a2.999 2.999 0 0 1-1.697.647c-.057.006-.122.029-.18.039H15.09c-.402 0-.8.075-1.172.222-.371.147-.709.363-.993.634-.285.272-.51.595-.664.95a2.812 2.812 0 0 0-.233 1.12v6.018c0 .096.02.186.03.28-.022.073-.055.152-.069.222a2.49 2.49 0 0 1-.633 1.3 2.855 2.855 0 0 1-1.624.761h-6.67c-.812 0-1.59.308-2.165.856A2.862 2.862 0 0 0 0 24.512v6.018c0 .776.323 1.52.897 2.07a3.136 3.136 0 0 0 2.165.857h7.114c.503.119.957.379 1.303.747.308.362.5.8.557 1.263.007.036.023.081.031.114-.02.12-.033.242-.037.363v6.018c0 .384.079.765.233 1.12.153.355.379.678.663.95.285.272.622.487.994.634.371.148.77.223 1.172.223h6.817c.065 0 .126-.014.19-.018.49.075.95.27 1.338.566.413.337.723.774.896 1.266v6.37c0 .776.323 1.52.897 2.07a3.136 3.136 0 0 0 2.166.857h6.819c.812 0 1.591-.308 2.166-.857a2.863 2.863 0 0 0 .897-2.07v-6.37a2.52 2.52 0 0 1 .863-1.167c.4-.302.882-.486 1.389-.53h6.82c.402 0 .8-.076 1.172-.223.371-.147.709-.363.993-.635.285-.272.51-.594.664-.95.154-.355.233-.735.233-1.12v-6.251c0-.776-.323-1.52-.897-2.07a3.136 3.136 0 0 0-2.166-.856h-6.818a1.757 1.757 0 0 1-.714-.161 1.683 1.683 0 0 1-.576-.434 1.52 1.52 0 0 1-.324-1.063v-.712ZM23.63 30.37c0 .385-.08.765-.233 1.12-.154.356-.38.678-.664.95a3.075 3.075 0 0 1-.993.635c-.372.147-.77.223-1.172.223h-5.134c-.403 0-.8-.076-1.172-.223a3.076 3.076 0 0 1-.994-.635 2.921 2.921 0 0 1-.664-.95 2.814 2.814 0 0 1-.233-1.12v-4.904c0-.384.08-.765.233-1.12a2.92 2.92 0 0 1 .664-.95c.284-.272.622-.488.994-.635.371-.147.77-.222 1.172-.222h5.133c.402 0 .8.075 1.172.222.371.147.709.363.993.635.285.272.51.595.664.95.154.355.233.736.233 1.12v4.904Zm12.63 11.318c0 .385-.08.765-.233 1.12-.154.355-.38.678-.664.95a3.077 3.077 0 0 1-.994.635c-.371.147-.77.222-1.172.222h-5.133a3.136 3.136 0 0 1-2.166-.857 2.863 2.863 0 0 1-.897-2.07v-4.91c0-.776.323-1.52.897-2.07a3.137 3.137 0 0 1 2.166-.857h5.132c.813 0 1.592.309 2.166.858.575.549.897 1.293.897 2.07l.001 4.91Zm0-22.629c0 .385-.08.765-.233 1.12-.154.356-.38.678-.664.95a3.077 3.077 0 0 1-.994.635c-.371.147-.77.222-1.172.222h-5.133a3.137 3.137 0 0 1-2.166-.857 2.863 2.863 0 0 1-.897-2.07v-4.91c0-.777.323-1.522.897-2.07a3.136 3.136 0 0 1 2.166-.858h5.132c.813 0 1.592.308 2.166.857.575.55.897 1.294.897 2.07l.001 4.911Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={2.804}
        x2={44.911}
        y1={18.083}
        y2={18.529}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5FC4AC" />
        <stop offset={1} stopColor="#3477BD" />
      </linearGradient>
    </defs>
  </svg>
);
export default CommonlandsLogoColorful;
